import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MenuComponent } from './menu/menu.component';
import { IonicModule } from '@ionic/angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { WaypointStatusModalComponent } from './waypoint-status-modal/waypoint-status-modal.component';

@NgModule({
  declarations: [
    MenuComponent,
    ChangePasswordComponent,
    WaypointStatusModalComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    RouterModule,
  ],
  exports: [
    MenuComponent,
    ChangePasswordComponent,
    WaypointStatusModalComponent
  ]
})
export class ComponentsModule { }
